import { render } from "./PageYorumlar.vue?vue&type=template&id=1011b282"
import script from "./PageYorumlar.vue?vue&type=script&lang=js"
export * from "./PageYorumlar.vue?vue&type=script&lang=js"
script.render = render

export default script